import Base from './Base'
import City from './City'

export default { Base, City }
